import { InventeringsNiva } from './../state-model/inge-api.model';
import { createSelector } from '@ngrx/store';
import { AbinState, InGeApiState } from '../state-model/inge-api.model';

export const getAbinState = (state: InGeApiState) => state.abin;

export const selectInvNiva = createSelector(getAbinState, (abin: AbinState) => {
    return abin.inventeringsNiva === InventeringsNiva.AFO || abin.inventeringsNiva === InventeringsNiva.STRATUM;
});
